var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92098 20.8757C16.2208 20.8757 20.7618 13.9977 20.7618 8.03488C20.7618 7.84152 20.7575 7.64386 20.7489 7.4505C21.6322 6.81168 22.3945 6.0204 23 5.11386C22.1773 5.47989 21.3038 5.71894 20.4094 5.82285C21.3512 5.25834 22.0563 4.37152 22.3941 3.32679C21.5082 3.85185 20.5393 4.22223 19.529 4.42206C18.8483 3.69877 17.9482 3.21986 16.968 3.05938C15.9879 2.89891 14.9821 3.0658 14.1063 3.53426C13.2304 4.00272 12.5333 4.74665 12.1227 5.65104C11.7121 6.55543 11.6108 7.5699 11.8346 8.53761C10.0406 8.44759 8.28561 7.98157 6.68332 7.16976C5.08102 6.35796 3.66722 5.21849 2.53355 3.82523C1.95737 4.81864 1.78105 5.99418 2.04044 7.11292C2.29984 8.23166 2.97547 9.20966 3.93004 9.84816C3.21341 9.82541 2.51248 9.63246 1.88516 9.28527V9.34113C1.88451 10.3836 2.24492 11.3942 2.90512 12.201C3.56531 13.0079 4.48455 13.5612 5.50656 13.7669C4.84272 13.9485 4.14598 13.975 3.47027 13.8443C3.75867 14.7408 4.31978 15.525 5.07529 16.0873C5.8308 16.6496 6.74303 16.9621 7.68465 16.981C6.08606 18.2367 4.11133 18.9178 2.07852 18.9146C1.71801 18.914 1.35787 18.8919 1 18.8484C3.06512 20.1733 5.4674 20.8769 7.92098 20.8757Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.94da79783197523071685d7a13ce7ee6.svg";
export { ForwardRef as ReactComponent };